// extracted by mini-css-extract-plugin
module.exports = {"policyTemplates":"policyTemplates___rFkIv","policyTemplate":"policyTemplate___k-ifX"};